<script lang="ts">
export default {
  name: 'Step2PolicyDocs',
};
</script>

<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useDataReadinessWizard } from '@/composables/useDataReadinessWizard';
import DocumentStatusTable from '@/components/v2/data_readiness/DocumentStatusTable.vue';

const wizard = useDataReadinessWizard();

onBeforeMount(() => wizard.refreshDocuments('Policy'));
</script>

<template>
  <div class="p-6">
    <h2 class="mb-1 text-base font-semibold">Policy documents</h2>
    <p class="mb-4 text-sm text-base-content/60">
      Review all policy documents for this client. Upload a file where missing, then publish to make documents visible on the client portal. At least
      one policy document must be uploaded and published to proceed.
    </p>
    <DocumentStatusTable document-type="Policy" />
  </div>
</template>
